import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { memo } from 'react';

const NavbarFeaturedContent = ({
  title,
  image,
  description,
  link,
  className,
  _testID,
  ...other
}) => {
  const linkObj = link?.link ? buildLinkObj(link) : null;
  const imgUrl = image ? buildImageSrc(image, 250, 12, 8) : null;

  const content = (
    <>
      {image && <img src={imgUrl} alt={image.name} className="tw-rounded tw-max-w-full" />}
      {description && (
        <Typography variant="body2" mt={2} mb={3}>
          {description}
        </Typography>
      )}
    </>
  );

  return (
    <Box className={className} {...other} data-test-id={`featured_content_${_testID}`}>
      {title && (
        <Typography
          variant="h6"
          mb={3}
          align="left"
          sx={{ fontSize: { sm: '1.25rem' }, lineHeight: { sm: '1.5rem' } }}
        >
          {title}
        </Typography>
      )}
      {linkObj ? (
        <a rel={getRel(linkObj)} href={linkObj.href} aria-label={linkObj.text}>
          {content}
        </a>
      ) : (
        <>{content}</>
      )}
    </Box>
  );
};

export default memo(NavbarFeaturedContent);
